export default function (state = {sessionId: null, isAuthenticated: false}, action) {
    switch (action.type) {
        case 'CLEAR_AGENCY_AUTHENTICATION':
            return {
                isAuthenticated: false,
                sessionId: null,
            };

        case 'SET_AGENCY_AUTHENTICATION':
            return action.authentication;

        default:
            return state;
    }
}
